import styled, { css } from 'styled-components';
import { Button, Label } from '../../../Components/uielements';
import { palette } from 'styled-theme';

// export const CompanyContainer = styled.div`
//   display: grid;
//   grid-auto-flow: column;
//   justify-content: space-between;
// `;

export const CompanyDetailsWrapper = styled.div`
  display: grid;
  /* grid-template-columns: 3fr 1fr; */
`;

export const CompanyDetailsLeft = styled.div`
  display: grid;
  position: relative;
  padding: 0px 20px;
  border-left: 1.5px solid ${palette('border', 0)};
  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: 260px;
    z-index: -1;
    /* background: ${palette('white', 0)} 0% 0% no-repeat padding-box; */
    /* border-radius: 0px 10px 10px 0px; */
    /* box-shadow: 17px 10px 20px ${palette('shadow', 1)}; */
  }
`;

export const CompanyLabel = styled(Label)`
  font-size: 16px;
  color: ${palette('text', 1)};
  justify-self: flex-start;
  ${(props) =>
    props.isCapitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const TwoColumns = styled.div`
  display: grid;
  padding: 5px 0px;
  grid-template-columns: 1fr 1fr;
  ${(props) =>
    props.isGap
      ? css`
          gap: 50px;
        `
      : css``}
`;
export const ThreeColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  ${(props) =>
    props.isGap
      ? css`
          gap: 50px;
        `
      : css``}
`;

export const MapWrapper = styled.div`
  display: grid;
  gap: 10px;
  min-width: 400px;
`;

export const AccountDeleteModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  max-width: 540px;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 500px;
  max-width: 700px;
  max-height: 500px;
`;
export const SectionTitle = styled(Label)`
  margin-bottom: 4px;
`;

export const SectionLabel = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 0.5px solid ${palette('border', 1)};
`;

export const StyledContainer = styled.div`
  padding: 20px;
`;

export const CompanyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 13px;
`;

export const SectionContainer = styled.div`
  background: transparent;
  border: 1px solid ${palette('border', 0)};
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  gap: 8px;
`;

export const LabelTitle = styled(Label)`
  font-weight: 500;
  color: #fff;
  min-width: 150px;
`;

export const Value = styled(Label)`
  color: #fff;
  text-transform: ${(props) => (props.isCapitalize ? 'capitalize' : 'none')};
`;

// Styled components for profile upload
export const ProfileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
`;

export const ProfileUploadWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
  overflow: hidden;
  background-color: #f5f5f5;

  &:hover {
    border-color: ${palette('border', 1)};
  }

  &.has-image {
    border: 3px solid ${palette('border', 1)};
  }
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const UploadIcon = styled.div`
  font-size: 24px;
  color: #999;
  text-align: center;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const UploadText = styled.p`
  margin-top: 10px;
  color: #666;
  font-size: 14px;
  text-align: center;
`;

export const SubmitButton = styled(Button)`
  &:hover {
    background-color: ${palette('background', 2)} !important;
    color: #171a3b !important;
  }
`;

export const ActionsWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ActionsButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: #e6b471;
  color: #11241f;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s ease,
    transform 0.05s ease;

  &:hover {
    background: #e6b471;
  }

  &:active {
    transform: translateY(1px);
  }

  .actions-arrow {
    transition: transform 0.15s ease;
    transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
  }
`;

export const ActionsMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: #0b2729;
  border: 1px solid rgba(224, 165, 92, 0.35);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  padding: 6px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 2px;
  animation: actions-menu-fade-in 0.12s ease-out;

  @keyframes actions-menu-fade-in {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ActionsMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: ${({ isWarning }) => (isWarning ? '#ff8a80' : '#f5f5f5')};
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease;

  svg {
    color: ${({ isWarning }) => (isWarning ? '#ff8a80' : '#e0a55c')};
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(224, 165, 92, 0.12);
  }
`;
